import React from "react"
import {  Row, Col } from "react-bootstrap"
import { css } from "@emotion/core"

import gradientArrow from '../../assets/images/about/gradientArrow.png'
import learn from '../../assets/images/about/learn.png'
import PropTypes from "prop-types"
import ExternalLink from "../ExternalLink"
import { mq } from "../../utils/media-queries"

const LearnAbout = ({ isAbout }) => {
  return (
    <Row>
      <Col
        css={css`
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          line-height: 21px;
          font-weight: bold;
          text-transform: uppercase;
          margin-bottom: 30px;
          margin: ${isAbout ? "0 15px" : "0 0 30px 0"};
          ${[mq[2]]} {
            height: 150px;
            margin-bottom: ${isAbout ? "0" : "20px"};
          }
        `}
      >
        <ExternalLink externalUrl="https://www.adcetris.com/classical-hodgkin-lymphoma/">
          <div
            css={css`
              width: 560px;
              height: 131px;
              box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.35);
              border-radius: 8px;
              background: linear-gradient(180deg, #58d0ff 0%, #01aef1 100%);
              display: flex;
              justify-content: space-around;
              align-items: center;
              ${[mq[2]]} {
                width: 360px;
              }
            `}
          >
            <img
                  loading='lazy'
                  css={css`
                    width: 85px;
                    margin-left: 20px;
                    ${[mq[2]]} {
                      width: 65px;
                    }
                  `}
                  src={learn}
                  alt='doctor icon'
                />
            <div
              css={css`
                width: 300px;
                color: #FFF;
                padding: 10px 0;
                ${[mq[2]]} {
                  width: 260px;
                  font-size: 13px;
                  line-height: 16px;
                }
              `}
              className="text-center"
            >
              Learn about a treatment <br />option for previously untreated Stage 3 or 4 classical Hodgkin Lymphoma
            </div>
            <img 
            loading='lazy' 
            css={css`
            width: 77px;
            margin-right: 15px;
            ${[mq[2]]} {
              width: 70px;
            }
          `}
            src={gradientArrow} alt='' />
          </div>
        </ExternalLink>
      </Col>
    </Row>
  )
}

LearnAbout.propTypes = {
  isAbout: PropTypes.bool,
}

export default LearnAbout
